import FacilioApp from "./app";
import { queryParameters } from "./util";

const FacilioAppSDK = {
  init: function (callback) {
    let loc = window.location;
    const queryParams = queryParameters(loc.search);
    const hashParams = queryParameters(loc.hash);
    const origin = queryParams.origin || hashParams.origin;
    const cappId = queryParams.capp_id || hashParams.capp_id;
    if (!origin || !cappId) {
      return false;
    }

    const app = new FacilioApp({ origin, cappId });

    if (typeof callback == "function") {
      app.on("app.loaded", (data) => {
        callback(data);
      });
    }

    return app;
  },
  initSync: function () {
    return new Promise((resolve, reject) => {
      let app = this.init((data) => {
        resolve(app);
      });
      if (!app) {
        reject(app);
      }
    });
  },
};

export default FacilioAppSDK;
